<template>
  <div class="section is-paddingless">
    <nav-bar></nav-bar>
    <div class="">
    <div class="container">
      <h1 class="title has-text-centered welcome">Welcome</h1>
      <form @submit.prevent="login" class="box is-radiusless">
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Username</label>
          </div>
          <div class="field-body">
            <div class="field">
              <p class="control">
                <input
                  class="input is-radiusless"
                  type="text"
                  autocomplete="username"
                  placeholder="me@example.com"
                  v-model="username"
                />
              </p>
            </div>
          </div>
        </div>
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Password</label>
          </div>
          <div class="field-body">
            <div class="field">
              <p class="control">
                <input
                  class="input is-radiusless"
                  type="password"
                  autocomplete="current-password"
                  placeholder="your password"
                  v-model="password"
                />
              </p>
            </div>
          </div>
        </div>
        <div class="has-text-centered">
          <button class="button is-rounded is-primary" type="submit">Log in</button>
        </div>
        <div class="has-text-centered ">
          <p v-if="error" class="error-message has-text-danger">{{error}}</p>
        </div>
        <p class="new-user-prompt has-text-centered">
          Not a dealer yet? Don't have a login? <a @click="toggleModal">Contact us.</a>
        </p>
      </form>
    </div>
    <modal :isActive="modalIsActive" @done="toggleModal">
      <new-user-entry @done="toggleModal"></new-user-entry>
    </modal>
    </div>
  </div>
</template>

<script>
import { login, setAuth } from '@/utils/api';
import router from '@/router';
import Modal from '@/components/Modal.vue';
import NewUserEntry from '@/components/NewUserEntry.vue';

export default {
  components: {
    modal: Modal,
    'new-user-entry': NewUserEntry,
  },
  props: ['redirect'],
  created() {
    localStorage.clear();
    setAuth();
  },
  data() {
    return {
      username: '',
      password: null,
      message: '',
      error: false,
      errorMessage: '',
      modalIsActive: false,
    };
  },
  methods: {
    async login() {
      try {
        const res = await login(this.username, this.password);
        if (res.details && res.details.authenticated) {
          this.error = '';
          console.log('loggin details', res.details);
          const { token, id: customerId, role, salesRole } = res.details;
          localStorage.setItem('ed-username', this.username);
          localStorage.setItem('ed-authToken', token);
          localStorage.setItem('ed-customerId', customerId);
          localStorage.setItem('ed-role', role);
          localStorage.setItem('ed-salesRole', salesRole);
          setAuth()
          if (this.redirect) {
            console.log(`redirecting to ${this.redirect}, user is logged in as ${localStorage.getItem('ed-customerId')}`);
            router.push({ path: this.redirect });
            return;
          }
          if (role === 'rep') {
            console.log('redirecting to customers, authtoken is', localStorage.getItem('ed-authToken'));
            router.push({ name: 'customers' });
          } else {
            router.push({ name: 'orders', params: { customerId } });
          }
        } else {
          this.error = 'Login failed. Try again.';
        }
      } catch (err) {
        if (err.response && err.response.status === 404) {
          this.error = 'User details not found.';
        } else {
          this.error = 'Something went wrong. Try again';
        }
      }
      // console.log(authenticated, authToken, role, id);
      // localStorage.setItem('ed-authToken', authToken);
    },
    toggleModal() {
      console.log('toggling', this.modalIsActive);
      this.modalIsActive = !this.modalIsActive;
    },
  },
};
</script>

<style scoped>
.section {
  height: 100%;
}

.section::after {
  content: "";
  background-image: url('~@/assets/images/logo-background.svg');
  background-repeat: repeat;
  opacity: 0.4;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: absolute;
  z-index: -1;
}

.new-user-prompt, .welcome {
  margin-top: 2rem;
  text-shadow: 2px 2px 4px #858585;
}

.container {
  max-width: 769px;
}
.field-body {
  flex-grow: 10;
}

.error-message {
  margin-top: 1em;
}
</style>
